<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">主题图管理</div>
          <span class="m-title-s">对主题图新增、编辑等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>主题图列表
            <span style="font-size: 14px;margin-left: 20px;color: #ff4d51;">(每个栏目一张图片)</span>
          </div>
          <div class="m-table-btn">
            <el-button @click="openPopup" type="primary" size="">新增主题</el-button>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border>
          <el-table-column prop="title" label="标题" width=""></el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="80">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === '1'" type="success">正常</el-tag>
              <el-tag v-else type="danger">关闭</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="类型" width="60" align="center"></el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="110" align="center"></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" width="110" align="center"></el-table-column>
          <el-table-column prop="remarks" label="备注" align="center"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row)" plain>编辑</el-button>
              <el-button type="danger" size="mini" @click="thisDel(scope.row.id)" plain>删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="750px" center :close-on-click-modal="false">
      <div class="m-open-container">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="125px">
            <el-form-item label="ID" prop="id" hidden>
              <el-input v-model="form.id" type="hidden"></el-input>
            </el-form-item>
            <el-form-item label="标题: " prop="title">
              <el-input v-model="form.title" placeholder="输入标题"></el-input>
            </el-form-item>
            <el-form-item label="报告图片: " prop="sort">
              <el-upload class="avatar-uploader"
                         :action="ossClientData.uploadUrl"
                         :show-file-list="false"
                         :http-request="ossUploadImg">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="图片路径: " prop="image">
              <el-input v-model="form.image" :disabled="true" placeholder="输入图片路径"></el-input>
            </el-form-item>
            <el-form-item label="类型: " prop="type">
              <el-input v-model="form.type" placeholder="输入类型"></el-input>
            </el-form-item>
            <el-form-item label="设置状态: " prop="isStatus">
              <el-switch v-model="isStatus" active-text="开启" inactive-text="关闭"></el-switch>
            </el-form-item>
            <el-form-item label="备注: " prop="remarks">
              <el-input v-model="form.remarks" type="textarea" :rows="2" placeholder="输入备注"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;" v-loading="formLoading">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'themeManage',
  data () {
    return {
      openText: '新增',
      openState: false,
      formLoading: false,
      isLoading: true,
      isStatus: true,
      list: [],
      imageUrl: '',
      ossClientData: {
        uploadUrl: '',
        region: '',
        accessKeyId: '',
        accessKeySecret: '',
        bucket: ''
      },
      form: {
        id: '',
        title: '',
        image: '',
        type: '',
        status: '',
        remarks: ''
      },
      rules: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'}
        ],
        // image: [
        //   {required: true, message: '请输入图片路径', trigger: 'blur'}
        // ],
        type: [
          {required: true, message: '请输类型', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    //  报告图片上传
    ossUploadImg (option) {
      let file = option.file
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 1
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
        return
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 1MB!')
        return
      }
      this.$axios.post('/admin/ossClient') // 获取oss参数
        .then((res) => {
          const self = this
          let timestamp = new Date().getTime() // 获取时间戳
          let randomStr = self.$pMethod.randomString(6)//  6位随机字符串
          let extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
          let fileName = 'theme/' + timestamp + '_' + randomStr + extensionName // 文件名字（相对于根目录的路径 + 文件名）
          // 执行上传
          self.$pMethod.createOssClient(res.data).then(client => {
            // 异步上传,返回数据 上传处理 分片上传文件
            client.multipartUpload(fileName, file, {
            }).then((val) => {
              if (val.res.statusCode === 200) {
                this.imageUrl = res.data.uploadUrl + val.name
                this.form.image = val.name
              } else {
                self.$message({message: '上传失败', type: 'error', center: true})
              }
            }, err => {
              self.$message({message: '上传失败', type: 'error', center: true})
              console.log(err)
            })
          })
        })
    },
    closeDialog: function () {
      this.form = {
        id: '',
        title: '',
        image: '',
        type: '',
        status: '',
        remarks: ''
      }
      this.imageUrl = ''
      this.openText = '新增'
      this.openState = false
      this.formLoading = false
    },
    openPopup () {
      this.openState = true
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.formLoading = true
          _this.form.status = _this.isStatus ? '1' : '0'
          this.$axios.post('/themeImage/save', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.listData()
                _this.openState = false
                _this.formLoading = false
              } else {
                _this.$message.error(res.msg)
                _this.formLoading = false
              }
            })
        } else {
          return false
        }
      })
    },
    thisDel (id) {
      let _this = this
      this.$messageBox.confirm('此操作将删除当前项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/themeImage/del', {id: id})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.listData()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    openForm (row) {
      let _this = this
      this.openText = '编辑'
      this.form = row
      _this.isStatus = row.status === '1'
      _this.imageUrl = row.image
      _this.openState = true
    },
    // 管理员列表
    listData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/themeImage/list')
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.listData()
  }
}
</script>
<style scoped>
  .avatar-uploader {border: 1px dashed #d9d9d9;width: 310px;height: 152px;border-radius: 6px;overflow: hidden;}
  .avatar-uploader:hover {border-color: #409EFF;}
  .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 310px;height: 152px;line-height: 152px;text-align: center;}
  .avatar {width: 310px; height: 152px; display: block;}
</style>



// WEBPACK FOOTER //
// src/components/platform/ThemeImage.vue